/* tslint:disable */
/* eslint-disable */
/**
 * Copyright Innov'ATM all rights reserved. This software is the property of Innov'ATM and may not be used in any
 * manner except under a license agreement signed with Innov'ATM.
 *
 * AK RMS API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ResourceOccupation } from './resource-occupation';
import { ResourceType } from './resource-type';
import { Towing } from './towing';

/**
 *
 * @export
 * @interface Flight
 */
export interface Flight {
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    clientAirportIata?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    id?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    flow?: FlightFlowEnum;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    arrDay?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    depDay?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    earliestArrDay?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    latestArrDay?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    earliestDepDay?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    latestDepDay?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    previousFlightId?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    nextFlightId?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    arrivalTrafficNature?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    departureTrafficNature?: string;
    /**
     *
     * @type {boolean}
     * @memberof Flight
     */
    cancelled: boolean;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    callsign?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    flightNumber?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    airlineIcao?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    airlineIata?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    firstAdepIata?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    firstAdepIcao?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    adepIata?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    adepIcao?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    lastAdesIata?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    lastAdesIcao?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    adesIata?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    adesIcao?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    departureTerminal?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    departureParking?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    arrivalTerminal?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    arrivalParking?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    registrationNumber?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    acTypeIata?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    acTypeIcao?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    wingspanCode?: FlightWingspanCodeEnum;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    latestArrivalTime?: number;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    latestDepartureTime?: number;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    earliestDepartureTime?: number;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    earliestArrivalTime?: number;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    aibt?: number;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    eibt?: number;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    sibt?: number;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    sobt?: number;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    eobt?: number;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    tobt?: number;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    pobt?: number;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    aobt?: number;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    ctot?: number;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    esbt?: number;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    tsbt?: number;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    asbt?: number;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    eebt?: number;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    tebt?: number;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    aebt?: number;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    departureHall?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    arrivalHall?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    departureGate?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    arrivalGate?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    counter?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    departureCarousel?: string;
    /**
     *
     * @type {string}
     * @memberof Flight
     */
    arrivalCarousel?: string;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    passengers?: number;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    paxCapacity?: number;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    paxUm?: number;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    paxPmr?: number;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    bags?: number;
    /**
     *
     * @type {boolean}
     * @memberof Flight
     */
    departureControlled: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Flight
     */
    arrivalControlled: boolean;
    /**
     *
     * @type {Array<ResourceType>}
     * @memberof Flight
     */
    alertsOnAllocatedResources?: Array<ResourceType>;
    /**
     *
     * @type {{ [key: string]: ResourceOccupation; }}
     * @memberof Flight
     */
    actualResourceOccupations: { [key: string]: ResourceOccupation };
    /**
     *
     * @type {{ [key: string]: ResourceOccupation; }}
     * @memberof Flight
     */
    scheduledResourceOccupation: { [key: string]: ResourceOccupation };
    /**
     *
     * @type {Array<Towing>}
     * @memberof Flight
     */
    towings: Array<Towing>;
    /**
     *
     * @type {number}
     * @memberof Flight
     */
    deleteTime?: number;
}

export const FlightFlowEnum = {
    ARR: 'ARR',
    DEP: 'DEP'
} as const;

export type FlightFlowEnum = (typeof FlightFlowEnum)[keyof typeof FlightFlowEnum];
export const FlightWingspanCodeEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D',
    E: 'E',
    F: 'F'
} as const;

export type FlightWingspanCodeEnum = (typeof FlightWingspanCodeEnum)[keyof typeof FlightWingspanCodeEnum];
